/* global module require */
const lib = require('./tv_addons.js');
lib.configurator = require('../tv_configurator/init_product.ts');
lib.configurator_v2 = require('../tv_configurator_v2/init_product.ts');
lib.products = require('../tv_products/products.ts');
lib.product_quotes = require('../tv_product_quotes/product_quotes.ts');
lib.product_videos = require('../tv_products_videos/thumbnail.ts');
module.exports = lib;
